import React from 'react';
import { Provider } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { AppLayout } from '../screens';
import { appStore } from '../redux-saga/store';

const App = () => (
  <Provider store={appStore}>
    <AppLayout />
  </Provider>
);

export default withTranslation()(App);
